import React from 'react';
import AnalyticsSetup from '../AnalyticsSetup';
import './demoAnalytics.css';

/* Analytics Setup — the legacy configuration surface (choose analysis type, author prompts &
   survey questions, manage analysis types and prompt templates) embedded in the new UI.
   Calls the existing analytics-setup endpoints on the agent server (3016). */
const DemoAnalyticsSetup = () => (
  <div className="demo-analytics h-full overflow-y-auto pb-4 pr-1">
    <AnalyticsSetup />
  </div>
);

export default DemoAnalyticsSetup;
